import { render, staticRenderFns } from "./UiModal.vue?vue&type=template&id=ec97a9c0&scoped=true&"
import script from "./UiModal.vue?vue&type=script&lang=js&"
export * from "./UiModal.vue?vue&type=script&lang=js&"
import style0 from "./UiModal.vue?vue&type=style&index=0&id=ec97a9c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec97a9c0",
  null
  
)

export default component.exports